import Banner from "../Banner";
import { toast } from "react-toastify";
import WebLayout from "layout/webLayout.js";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const DonateItemsDropoff = () => {
  const [select, setSelect] = useState("");
  const [active, setActive] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (e) => {
    setSelect(e.target.value);
  };

  const handleSubmit = () => {
    if (!select) {
      toast.error("Please select a dropoff option");
      return;
    } else {
      let path = "/donate-items/category/pickup";
      navigate(path, { state: { ...location.state, address: select } });
    }
  };

  const dropOffAddresses = [
    {
      address: "3rd avenue, F1 close, Festac Town",
      addressLGA: "Amuwo Odofin",
      addressState: "Lagos",
      supportInfo: "Praise AK 09061616292",
      openingHours: "Mon - Sat. 8am - 7pm",
      value: "3rd avenue, F1 close, Festac Town",
    },
    {
      address: "No 2 Utomi Aire, off Freedom way",
      addressLGA: "Lekki phase 1",
      addressState: "Lagos",
      supportInfo: "Praise AK 09061616292",
      openingHours: "Mon - Sat. 8am - 7pm",
      value: "No 2 Utomi Aire, off Freedom way",
    },
  ];

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <WebLayout>
      <Banner />
      <div className="flex justify-center items-center">
        <div className="w-4/5 md:w-3/5 py-24 px-8 flex justify-center items-center">
          <div className="flex flex-col gap-4 justify-center items-center">
            <p className="text-[#213874] text-[24px] font-bold text-center">
              We need you to pick a drop-off location
            </p>
            <div className="flex flex-wrap gap-5">
              {dropOffAddresses.map((address, idx) => (
                <div key={idx} className="w-full">
                  <label
                    onClick={() => setActive(idx)}
                    className={`w-full flex justify-between border border-[#213874] py-8 px-8 ${
                      active === idx && `bg-[#d8dce4] border-[#d8dce4]`
                    }`}
                  >
                    <div className="flex flex-col gap-2">
                      <p className="italic text-[#213874] font-medium text-[16px] whitespace-nowrap">
                        {address.address}
                      </p>
                      <p className="text-[#7A7A7A] text-[12px]">
                        {address.addressLGA}
                      </p>
                      <p className="text-[#7A7A7A] text-[12px]">
                        {address.addressState}
                      </p>
                      <p className="text-[#213874] font-medium text-[16px]">
                        Support Information
                      </p>
                      <p className="text-[#7A7A7A] text-[12px]">
                        {address.supportInfo}
                      </p>
                      <p className="text-[#213874] font-medium text-[16px]">
                        Opening Hours
                      </p>
                      <p className="text-[#7A7A7A] text-[12px]">
                        {address.openingHours}
                      </p>
                    </div>
                    <input
                      onChange={handleChange}
                      type="radio"
                      checked={select === address.value}
                      value={address.value}
                      name={address.value}
                    />
                  </label>
                </div>
              ))}
            </div>
            <button className="w-full" onClick={handleSubmit}>
              <p className="w-full flex justify-center items-center bg-[#213874] hover:bg-[#192b5b] py-3 px-8 h-[50px] rounded-3xl text-white">
                Continue
              </p>
            </button>
          </div>
        </div>
      </div>
    </WebLayout>
  );
};

export default DonateItemsDropoff;
